<div class="bi" id="pbi-report" #powerBIReports></div>
<div *ngIf="relatorioGerado" class="data">Data da Última Atualização: {{dtAtualizacao}}</div>